// Catalogue lots / statuts pour le frontend
export const LOT_STATUTS = [
  { key: 'a_demarrer', label: 'A demarrer', color: 'bg-gray-100 text-gray-700' },
  { key: 'en_cours',   label: 'En cours',   color: 'bg-blue-100 text-blue-700' },
  { key: 'termine',    label: 'Termine',    color: 'bg-emerald-100 text-emerald-700' },
  { key: 'suspendu',   label: 'Suspendu',   color: 'bg-amber-100 text-amber-700' },
];

export const LOT_STATUT_MAP = LOT_STATUTS.reduce((acc, s) => {
  acc[s.key] = s; return acc;
}, {});

// Corps d'etat usuels en BTP - pre-remplissage des selecteurs
export const CORPS_ETAT_BTP = [
  'gros_oeuvre', 'charpente', 'couverture', 'facade', 'menuiserie',
  'cloisons', 'plomberie', 'cvc', 'electricite', 'finitions',
  'peinture', 'carrelage', 'vrd', 'paysage', 'demolition', 'autre',
];
